import React, { useState } from 'react';
import ProductTopSection from './product-top-section';
import ProductAboutSection from './product-about-section';
import ProductCustomizer from './product-customizer';
import SizeGuide from './size-guide';

import { AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';

const Product = ({ product, assets, reviews }) => {
    const [isCustomizerOpen, setIsCustomizerOpen] = useState(false);
    const [isSizeGuideOpen, setIsSizeGuideOpen] = useState(false);
    useEffect(() => {
        const isBrowser = typeof window != 'undefined';
        if (isBrowser) {
            const url = window.location.href;
            if (
                window.location.search &&
                window.location.search.includes('customize')
            ) {
                setIsCustomizerOpen(true);
            }
        }
    }, []);
    return (
        <>
            <ProductTopSection
                isCustomizerOpen={isCustomizerOpen}
                setIsCustomizerOpen={setIsCustomizerOpen}
                product={product}
                setIsSizeGuideOpen={setIsSizeGuideOpen}
            />
            <ProductAboutSection
                product={product}
                assets={assets}
                reviews={reviews}
            />
            {/* trigger url change. */}
            <AnimatePresence>
                {isCustomizerOpen && (
                    <ProductCustomizer
                        isCustomizerOpen={isCustomizerOpen}
                        setIsCustomizerOpen={setIsCustomizerOpen}
                        product={product}
                    />
                )}
            </AnimatePresence>
            <AnimatePresence>
                {isSizeGuideOpen && (
                    <SizeGuide
                        isSizeGuideOpen={isSizeGuideOpen}
                        setIsSizeGuideOpen={setIsSizeGuideOpen}
                    />
                )}
            </AnimatePresence>
        </>
    );
};

export default Product;
